import { createContext, useContext, useState, useCallback } from 'react'

const PlantContext = createContext(null)

// SAP plant code, matching models.DefaultPlantCode. All data is stored under
// SAP codes; 'FBO' matched nothing, so every plant-scoped screen came up empty.
const DEFAULT_PLANT = { plantCode: '1002', name: 'Faribault, MN Plant', city: 'Faribault, MN' }

export function PlantProvider({ children }) {
  const [plant, setPlant] = useState(DEFAULT_PLANT)
  const [planContext, setPlanContext] = useState(null)
  const [scenarioContext, setScenarioContext] = useState(null)

  const switchPlant = useCallback((p) => {
    setPlant(p)
    setPlanContext(null)
    setScenarioContext(null)
  }, [])

  return (
    <PlantContext.Provider value={{
      plant,
      switchPlant,
      planContext,
      setPlanContext,
      scenarioContext,
      setScenarioContext,
    }}>
      {children}
    </PlantContext.Provider>
  )
}

export function usePlantContext() {
  const ctx = useContext(PlantContext)
  if (!ctx) throw new Error('usePlantContext must be used within PlantProvider')
  return ctx
}
